import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  padding: 3px 10px;
  border-radius: 12px;
  background: ${({ $color }) => `${$color}15`};
  color: ${({ $color }) => $color};
  font-weight: 500;
  border: 1px solid ${({ $color }) => `${$color}30`};
`;
